import BaseSiteLayout from "../../layouts/BaseSiteLayout/BaseSiteLayout";
import { useState, useEffect } from "react";
import { Check, X } from "lucide-react";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import Testimonials from "../../components/Paywall/Testimonials";
import FAQ from "../../components/Paywall/FAQ";
import PaymentButton from "../../payments/PaymentButton/PaymentButton";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { getCountdownFrom72Hours } from "../../utils/timeUtils";


export default function Pricing() {
    const { userCreatedAt } = useAuth();
    const timer = getCountdownFrom72Hours(userCreatedAt);
    const price = timer === false ? 18 : 12;

    const isMobile = window.innerWidth <= 768;

    return (
        <BaseSiteLayout isBeta={true} >
            <div
                className="relative w-full flex flex-col gap-12 items-center md:pb-16 pb-6 md:px-20"
                onClick={(e) => e.stopPropagation()}
            >

                {/* Title */}
                <div className="flex flex-col gap-2 md:gap-3 items-center">
                    <Typography size="40" desktopSize="82" weight="sb" family="serif" align="center">
                        Dì addio allo stress da tesi!
                    </Typography>
                    <Typography size="16" desktopSize="20" weight="md" color="gray-600" align="center">
                        Sblocca Athena e rendi tutto più semplice.
                    </Typography>
                </div>

                {/* Pricing Plans */}
                <div className="flex md:flex-row flex-col gap-3 md:gap-8 w-full h-full">
                    {/* Free Plan */}
                    <div className="w-full p-4 md:p-6 bg-white border-2 border-gray-100 rounded-[20px] flex flex-col justify-between md:gap-none gap-6">
                        <div className="flex flex-col gap-2 items-start">
                            <Typography size="12" desktopSize="20" weight="md">
                                Piano attuale
                            </Typography>
                            <Typography size="32" desktopSize="64" weight="sb" family="serif">
                                Gratis
                            </Typography>
                            <div className="flex flex-col gap-3 items-start">
                                {["7 giorni di prova gratuita", "Funzionalità limitate", "Assistenza secondaria"].map((text) => (
                                    <div className="flex gap-[10px] items-center" key={text}>
                                        <Check size={16} />
                                        <Typography size="12" desktopSize="16" weight="rg">{text}</Typography>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <Button size={isMobile ? "sm" : "md"} text="Continua" type="bw" width="full" />
                    </div>

                    {/* Pro Plan */}
                    <div className="w-full relative p-4 md:p-6 bg-white border-2 border-gray-100 rounded-[20px] flex flex-col gap-9">
                        {timer !== false && (
                            <div className="hidden md:block absolute top-0 end-0 p-4">
                                <Button size="sm" text="50% di benvenuto" type="color" width="fit" />
                            </div>
                        )}
                        <div className="flex flex-col gap-2 items-start">
                            <Typography size="12" desktopSize="20" weight="md">Pro</Typography>
                            <div className="flex gap-3 items-center">
                                <Typography size="32" desktopSize="64" weight="sb" family="serif">€{price}</Typography>
                                <Typography size="12" desktopSize="16" weight="rg" color="gray-600">al mese</Typography>
                            </div>
                            <div className="flex flex-col gap-3 items-start">
                                {["Strumenti di revisione avanzati", "Gestione intelligente delle fonti", "Generazione automatica dell’indice", "Roadmap personalizzata", "Accesso prioritario a nuove funzionalità"].map((text) => (
                                    <div className="flex gap-[10px] items-center" key={text}>
                                        <Check size={16} />
                                        <Typography size="12" desktopSize="16" weight="rg">{text}</Typography>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <PaymentButton price={price} />
                        {/* <Button size={isMobile ? "sm" : "md"} text="Vai al pagamento" type="color" width="full" /> */}
                    </div>
                </div>

                {/* Footer */}
                <div className="flex w-full items-center gap-2">
                    <div className="flex-1 text-end">
                        <Typography size="12" desktopSize="16" weight="rg">Disdici quando vuoi</Typography>
                    </div>
                    <div className="w-[4px] h-[4px] bg-black rounded-full" />
                    <div className="flex-1 text-start">
                        <Typography size="12" desktopSize="16" weight="rg">Pagamento con PayPal</Typography>
                    </div>
                </div>

                {/* Testimonials */}
                <div className="flex gap-2 md:gap-6 w-full">
                    <Testimonials isPage={true}/>
                </div>

                {/* FAQ */}
                <div className="flex flex-col gap-6 items-center w-full">
                    <Typography size="32" desktopSize="48" family="serif" weight="sb">Domande?</Typography>
                    <div className="flex flex-col w-full gap-3">
                        <FAQ />
                    </div>
                </div>
            </div>
        </BaseSiteLayout>
    )
}